import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "./library/link";
import { Teasers } from "./teaser";
export class ContentGridBlock extends React.Component {
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsxs("section", {
            className: "block block--content-grid",
            children: [
                p.title && p.title != "" && /*#__PURE__*/ _jsx("header", {
                    className: "block__header",
                    children: /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l",
                        children: p.title
                    })
                }),
                /*#__PURE__*/ _jsx(Teasers, {
                    row_count: p.row_count,
                    keyPrefix: "content-grid-item-",
                    items: p.items.map((i)=>({
                            extraClasses: 'block__item',
                            headingLevel: p.title && p.title != "" ? 'h3' : 'h2',
                            title: i.title,
                            linkUrl: i.linkUrl,
                            intro: i.subtitle,
                            label: i.label,
                            imageUrl: i.imageUrl,
                            imageUrlFallback: i.imageUrlFallback,
                            imageAlt: i.imageAlt,
                            video: i.video
                        })).toList()
                }),
                p.primaryActionTitle && p.primaryActionUrl && /*#__PURE__*/ _jsx(Link, {
                    className: "link grid__button",
                    url: p.primaryActionUrl,
                    children: p.primaryActionTitle
                })
            ]
        });
    }
}
